export const externalPage = {
  taskInvitation: "Task Invitation",
  interestedTaskMsg: "Are you interested in this task?",
  reject: "Reject",
  accept: "Accept",
  inviteAssigneeAcceptMsg: "Thank you for expressing interest in this task!",
  inviteAssigneeRejectMsg:
    "Thank you for reviewing this task. You have rejected the invitation.",
  approvalRequest: "Approval Request",
  POAssigneeAcceptMsg:
    "Do you confirm the details of this task, including the attached Purchase Order?",
  rejectRequest: "Reject Request",
  POAssigneeDeclineMsg:
    "Do you confirm the rejection of this task, including the attached Purchase Order?",
  rejectTask: "You have reject the task. Thank you",
  requestPayment: "Request Payment",
  requestPaymentMsg:
    "Do you want to confirm the invoice for the task with PO ({{poNumber}})?",
  confirm: "Confirm",
  requestPaymentSuccessMsg:
    "Your payment request has been successfully submitted.",
  uploadInvoice: "Upload an Invoice",
  invoice: "Invoice",
  poAcceptMsg: "Thank you for accepting this task.",

};
